import { ConnectedPosition, OverlayModule } from "@angular/cdk/overlay";
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import { ResponsiveText } from "../responsive-text";

import { UncontrolledSelectOption } from "./types/uncontrolled-select-option.interface";
import { UncontrolledSelectList } from "./uncontrolled-select-list";

@Component({
  selector: "pax-uncontrolled-select",
  standalone: true,
  imports: [
    ReactiveFormsModule,
    OverlayModule,
    UncontrolledSelectList,
    ResponsiveText,
  ],
  templateUrl: "./uncontrolled-select.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UncontrolledSelect implements AfterViewChecked {
  @ViewChild("selectTrigger")
  trigger!: ElementRef<HTMLButtonElement>;

  @Input({ required: true }) id!: string;
  @Input() options: UncontrolledSelectOption[] | undefined;
  @Input() selectedValue: UncontrolledSelectOption | undefined;
  @Output() changedSelection = new EventEmitter();

  private _isOpen = false;
  protected buttonWidth!: number;

  ngAfterViewChecked() {
    this.buttonWidth = this.trigger.nativeElement.offsetWidth;
  }

  get buttonId() {
    return `${this.id}-button`;
  }

  get modalPositions(): ConnectedPosition[] {
    return [
      {
        originX: "end",
        originY: "bottom",
        overlayX: "end",
        overlayY: "top",
      },
    ];
  }

  get label() {
    if (!this.selectedValue) {
      return this._emptyLabel;
    }

    return this.selectedValue.label ?? this.selectedValue.value;
  }

  get mobileLabel() {
    if (!this.selectedValue) {
      return this._emptyLabel;
    }

    return this.selectedValue.mobileLabel ?? this.selectedValue.value;
  }

  get isOpen() {
    return this._isOpen;
  }

  close() {
    this._isOpen = false;
  }

  switch() {
    this._isOpen = !this._isOpen;
  }

  private get _emptyLabel() {
    return $localize`Wählen Sie eine Option aus.`;
  }
}
